import { Set } from 'immutable'

/**
 * AWS S3 Storage
 */
export const MEDIA_ASSETS_PROVIDER_AWS_S3 = 'AWS_S3'

/**
 * Brightcove HLS service
 */
export const MEDIA_ASSETS_PROVIDER_BRIGHTCOVE_HLS = 'BRIGHTCOVE_HLS'

/**
 * Brightcove Dyanmic Delivery service
 */
export const MEDIA_ASSETS_PROVIDER_BRIGHTCOVE_DYNAMIC_DELIVERY = 'BRIGHTCOVE_DYNAMIC_DELIVERY'

/**
 * Brightcove Yoga International account
 */
export const MEDIA_ASSETS_PROVIDER_BRIGHTCOVE_YOGA_INTERNATIONAL = 'BRIGHTCOVE_YOGA_INTERNATIONAL'

/**
 * Gaia HLS service
 */
export const MEDIA_ASSETS_PROVIDER_HLS = 'HLS'

/**
 * Get a list of media asset providers that use bright cove which is useful for
 * linking to the CMS
 */
export function getMediaAssetProviderBrightcove () {
  return Set([
    MEDIA_ASSETS_PROVIDER_BRIGHTCOVE_HLS,
    MEDIA_ASSETS_PROVIDER_BRIGHTCOVE_DYNAMIC_DELIVERY,
    MEDIA_ASSETS_PROVIDER_HLS,
  ])
}
